import { BeatLoader } from 'react-spinners';

const BadgeLoading = ({ right = '12px' }: { right?: string }) => {
  // rendering badge loading component here
  return (
    <div
      style={{ right }}
      className='justify-end absolute top-1/2 -translate-y-1/2'
    >
      <BeatLoader size={5} color='#111C43' />
    </div>
  );
};

export default BadgeLoading;
